import { render, staticRenderFns } from "./RepertoryDetail.vue?vue&type=template&id=4f7d6621&scoped=true&"
import script from "./RepertoryDetail.vue?vue&type=script&lang=js&"
export * from "./RepertoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d6621",
  null
  
)

export default component.exports